/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventLogEntryList } from '../../models/event-log-entry-list';
import { EventLogGroupName } from '../../models/event-log-group-name';
import { EventLogSearchBody } from '../../models/event-log-search-body';
import { EventLogSortFieldName } from '../../models/event-log-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface GetEventsLogByGroup$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for grouping the data:
 *   * DATE : the date (truncated on day)
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 *   * GROUP : the tag group
 */
  groupName?: EventLogGroupName & any;

/**
 * The value of the group for a group field (can be null)
 */
  groupValue?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 */
  sortFieldName?: EventLogSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search events log
     */
    body?: EventLogSearchBody
}

export function getEventsLogByGroup(http: HttpClient, rootUrl: string, params: GetEventsLogByGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogEntryList>> {
  const rb = new RequestBuilder(rootUrl, getEventsLogByGroup.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('groupName', params.groupName, {});
    rb.query('groupValue', params.groupValue, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventLogEntryList>;
    })
  );
}

getEventsLogByGroup.PATH = '/stations/{uid}/eventslog/group/search';
